import { graphql } from "gql";

const DISTRIBUTION_GROUP_QUERY = graphql(`
  query DistributionGroup($id: [ID!]!) {
    distributionGroups: distributionGroup(id: $id) {
      ...DistributionGroup
    }
  }
`);

export default DISTRIBUTION_GROUP_QUERY;
